import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_DOSE_REMINDER_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.SAVE_DOSE_REMINDER_SUCCESS: {
      return {
        ...state,
        data: action.response,
        isProgress: false,
      };
    }
    case homeConstants.SAVE_DOSE_REMINDER_FAILURE: {
      return {
        ...state,
        data: {},
        isProgress: false,
      };
    }
    case homeConstants.RESET_DOSE_REMINDER_INFO:
      return {
        ...state,
        data: {},
        isProgress: false,
      };
    default:
      return state;
  }
}
